import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=d196f46a&scoped=true&"
import script from "./ModalWrapper.vue?vue&type=script&lang=ts&"
export * from "./ModalWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ModalWrapper.vue?vue&type=style&index=0&id=d196f46a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d196f46a",
  null
  
)

export default component.exports